"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.synthscape = void 0;
const fizz_1 = require("./fizz");
const hearthHarmony_1 = require("./hearthHarmony");
exports.synthscape = Object.assign(Object.assign({}, fizz_1.fizz), { group: hearthHarmony_1.hearthHarmony.group, parentGroup: hearthHarmony_1.hearthHarmony.parentGroup, app: { name: "SPONSORSHIP PROGRAMS" }, company: {
        name: "Synthscape",
        logo: {
            url: "/custom/synthscape/logo.svg",
            description: "synthscape",
        },
        icon: "/custom/synthscape/tags/favicon.ico",
        image: "/custom/synthscape/tags/logo.png",
    }, footerLinks: [
        {
            text: "Synthscape Privacy Policy",
            url: "https://www.max.live/privacy-policy",
        },
        { text: "MAX Privacy Policy", url: "https://www.max.live/privacy-policy" },
    ], fanAppUrl: `https://synthscape.live`, onsiteAppUrl: `https://onsite.synthscape.live`, privacyPolicyUrl: "https://www.max.live/privacy-policy", regionsCollection: "synthscape_regions", menu: {
        sections: {
            engagement: {
                header: "User Engagement",
                items: {
                    live: {
                        label: "Synthscape.Live",
                    },
                },
            },
        },
    } });
